import { IonIcon } from "@ionic/react";
import {
  caretDownOutline,
  caretForwardOutline,
  closeOutline,
} from "ionicons/icons";
import { useState } from "react";
import ForumAndDebriefRules from "../siteRules/ForumAndDebriefRules";
import { nightModeStyle } from "../../publicFunctions/publicHelpers/helpers";
import { submitReport } from "../../config/firebase";
import Lottie from "react-lottie-player";
import loadingAnimation from "../../img/animations/loadinganimation.json";

function CreateReportsBody({
  rulesType,
  type,
  nightMode,
  reportCompleted,
  closeReport,
  objectId,
}) {
  const [selectedReason, setSelectedReason] = useState("");
  const [openReasonSelect, setOpenReasonSelect] = useState(false);
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState(
    "Please select a reason for the report."
  );
  const [isWorking, setIsWorking] = useState(false);

  const changeSelectedReason = (tempSelectedReason) => {
    setSelectedReason(tempSelectedReason);
    setOpenReasonSelect(false);
    setErrorMessage("");
  };

  const handleSubmitReport = async () => {
    setIsWorking(true);
    try {
      const { data } = await submitReport({
        type,
        objectId,
        message,
        reason: selectedReason,
      });

      if (!data.success) {
        if (data.message) {
          setErrorMessage(data.message);
        } else {
          setErrorMessage(
            "Something went wrong. Please contact admin@writingbattle.com"
          );
        }
      } else {
        // Success!!
        reportCompleted();
      }
    } catch (err) {
      if (err) {
        setErrorMessage(
          "Something went wrong. Please contact admin@writingbattle.com"
        );
      }
    } finally {
      setIsWorking(false);
    }
  };

  return (
    <div className="flex justify-content--end">
      <div className="flex flex--direction-column align-items--end flex--gap-smaller">
        <div
          className="cursor--pointer"
          onClick={(event) => {
            event.preventDefault();
            closeReport();
          }}
        >
          <IonIcon className="social-icon" icon={closeOutline} />
        </div>
        <div
          onClick={(event) => {
            event.preventDefault();
            setOpenReasonSelect(!openReasonSelect);
          }}
          className="flex align-items--center cursor--pointer "
        >
          <IonIcon
            className="social-icon"
            icon={openReasonSelect ? caretDownOutline : caretForwardOutline}
          />
          <p className="description underline bold">
            (*) {selectedReason ? "Change" : "Choose"} Reason for Report
          </p>
        </div>
        {openReasonSelect ? (
          <div className="flex flex--direction-column">
            <ForumAndDebriefRules
              rulesType={rulesType}
              readOnly={false}
              selectedReason={selectedReason}
              changeSelectedReason={changeSelectedReason}
              forReports={true}
            />
          </div>
        ) : null}
        {!openReasonSelect && selectedReason ? (
          <p className="description">
            Selected Reason:{" "}
            {selectedReason.slice(0, 30) +
              (selectedReason.length > 30 ? "..." : "")}
          </p>
        ) : null}

        {selectedReason ? (
          <textarea
            style={nightMode ? nightModeStyle : {}}
            id="report-reason"
            className="feedback-text-area text-area--resize-vertical"
            value={message}
            disabled={isWorking}
            onChange={(event) => {
              setMessage(event.target.value);
            }}
            placeholder="Message to mods (OPTIONAL)"
          />
        ) : null}
        {errorMessage ? (
          <p className="description--small bold">{errorMessage}</p>
        ) : null}
        <button
          className="btn btn--full min-width--larger btn--full--spring"
          disabled={isWorking || !selectedReason}
          onClick={handleSubmitReport}
        >
          <div className="flex flex--gap-normal align-items--center justify-content--center">
            <p className="description">Submit Report</p>{" "}
            <div className={isWorking ? "simple-loader" : "hidden"}>
              <Lottie loop animationData={loadingAnimation} speed={1.5} play />
            </div>
          </div>
        </button>
      </div>
    </div>
  );
}

export default CreateReportsBody;
